/*
 * @file: index.js
 * @description: It Contain rest functions for api call .
 * @author: Poonam
 */

import api from "../../api/apiClient";
import { setAuthorizationToken } from "../auth";
import { toast } from "react-toastify";
import loader from "../loader";
import environment from "../../environment";
import methodModel from "../methods";
import Swal from "sweetalert2";

var config = {
  headers: { "Content-Type": "application/json" },
};

var baseUrl = environment?.api || 'https://kindaapi.jcsoftwaresolution.in/';

const getFullUrl = (url1, base) => {
  if (url1 && (url1.startsWith('http://') || url1.startsWith('https://'))) {
    return url1;
  }
  const b = base || baseUrl || '';
  if (!b) return url1;
  const cleanBase = b.endsWith('/') ? b : `${b}/`;
  const cleanUrl = url1.startsWith('/') ? url1.slice(1) : url1;
  return cleanBase + cleanUrl;
};


const handleError = (err, hideError) => {
  let message = "";
  if (err) {
    if (err && err.error && err.error.code == 401) {
      // dispatch(logout());
      localStorage.removeItem("persist:admin-app");
      localStorage.removeItem("token");
      document.getElementById("handleLogout")?.click();
      hideError = true;
      methodModel.route("/");
    }
    message = err && err.error && err.error.message;
    if (!message) message = err.message;
    if (!message) message = "Server Error";
  }

  const lowerMsg = (message || "").toLowerCase();
  const isLimitError =
    lowerMsg.includes("reached your limit") ||
    lowerMsg.includes("reached limit") ||
    lowerMsg.includes("limit reached") ||
    lowerMsg.includes("exceeded your limit") ||
    lowerMsg.includes("limit exceeded") ||
    lowerMsg.includes("upgrade your plan") ||
    lowerMsg.includes("upgrade the plan") ||
    lowerMsg.includes("don't have limits") ||
    lowerMsg.includes("no active plan");

  if (isLimitError) {
    hideError = true;
    Swal.fire({
      title: "Plan Limit Reached",
      text: message || "You have reached your limit. If you want to add more, you need to upgrade your plan.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#494f9f",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Upgrade Plan",
      cancelButtonText: "Close",
    }).then((result) => {
      if (result.isConfirmed) {
        methodModel.route("/plan");
      }
    });
  }

  if (!hideError) toast.error(message);
};


class ApiClient {
  static post(url1, payload, params = {}, base = "", hideError = false) {
    let url = getFullUrl(url1, base);

    setAuthorizationToken(api);
    return new Promise(function (fulfill, reject) {
      api
        .post(url, payload, { ...config, params: params })
        .then(function (response) {
          if (response?.data && response.data.success === false && response.data.message) {
            const lMsg = (response.data.message || "").toLowerCase();
            if (
              lMsg.includes("reached your limit") ||
              lMsg.includes("limit reached") ||
              lMsg.includes("reached limit") ||
              lMsg.includes("exceeded your limit") ||
              lMsg.includes("limit exceeded")
            ) {
              handleError(response.data, hideError);
            }
          }
          fulfill(response && response.data);
        })
        .catch(function (error) {
          loader(false);
          if (error && error.response) {
            let eres = error.response;
            handleError(eres.data, hideError);
            fulfill({ ...eres.data, success: false });
          } else {
            toast.error("Network Error");
            reject(error);
          }
        });
    });
  }

  static put(url1, payload, base = "") {
    let url = getFullUrl(url1, base);
    setAuthorizationToken(api);
    return new Promise(function (fulfill, reject) {
      api
        .put(url, payload, config)
        .then(function (response) {
          if (response?.data && response.data.success === false && response.data.message) {
            const lMsg = (response.data.message || "").toLowerCase();
            if (
              lMsg.includes("reached your limit") ||
              lMsg.includes("limit reached") ||
              lMsg.includes("reached limit") ||
              lMsg.includes("exceeded your limit") ||
              lMsg.includes("limit exceeded")
            ) {
              handleError(response.data);
            }
          }
          fulfill(response && response.data);
        })
        .catch(function (error) {
          loader(false);
          if (error && error.response) {
            let eres = error.response;
            handleError(eres.data);
            fulfill(eres.data);
          } else {
            toast.error("Network Error");
            reject(error);
          }
        });
    });
  }

  static putWithoutError(url1, payload, base = "") {
    let url = getFullUrl(url1, base);
    setAuthorizationToken(api);
    return new Promise(function (fulfill, reject) {
      api
        .put(url, payload, config)
        .then(function (response) {
          fulfill(response && response.data);
        })
        .catch(function (error) {
          loader(false);
          if (error && error.response) {
            let eres = error.response;
            // handleError(eres.data);
            fulfill(eres.data);
          } else {
            toast.error("Network Error");
            reject(error);
          }
        });
    });
  }

  static get(url1, params = {}, base = "", hidError = "") {
    let url = getFullUrl(url1, base);
    setAuthorizationToken(api);
    return new Promise(function (fulfill, reject) {
      api
        .get(url, { ...config, params: params })
        .then(function (response) {
          fulfill(response && response.data);
        })
        .catch(function (error) {
          loader(false);
          if (error && error.response) {
            let eres = error.response;
            handleError(eres.data, hidError);
            fulfill({ ...eres.data, success: false });
          } else {
            toast.error("Network Error");
            reject(error);
          }
        });
    });
  }

  static delete(url1, params = {}, base = "") {
    let url = getFullUrl(url1, base);

    setAuthorizationToken(api);
    return new Promise(function (fulfill, reject) {
      api
        .delete(url, { ...config, params: params })
        .then(function (response) {
          fulfill(response && response.data);
        })
        .catch(function (error) {
          loader(false);
          if (error && error.response) {
            let eres = error.response;
            handleError(eres.data);
            fulfill(eres.data);
          } else {
            toast.error("Network Error");
            reject(error);
          }
        });
    });
  }

  static allApi(url, params, method = "get") {
    if (method == "get") {
      return this.get(url, params);
    } else if (method == "put") {
      return this.put(url, params);
    }
    if (method == "post") {
      return this.post(url, params);
    }
  }

  /*************** Form-Data Method ***********/
  static postFormData(url1, params) {
    let configupdate = {
      headers: { "Content-Type": "multipart/form-data" },
    };
    let url = getFullUrl(url1);
    setAuthorizationToken(api);
    return new Promise(function (fulfill, reject) {
      var body = new FormData();
      let oArr = Object.keys(params);
      oArr.map((itm) => {
        body.append(itm, params[itm]);
      });

      api
        .post(url, body, configupdate)
        .then(function (response) {
          fulfill(response && response.data);
        })
        .catch(function (error) {
          loader(false);
          if (error && error.response) {
            let eres = error.response;
            handleError(eres.data);
            fulfill(eres.data);
          } else {
            toast.error("Network Error");
            reject(error);
          }
        });
    });
  }

  static postFormFileData(url1, params, base = "") {
    let configupdate = {
      headers: { "Content-Type": "multipart/form-data" },
    };
    let url = getFullUrl(url1, base);
    setAuthorizationToken(api);
    return new Promise(function (fulfill, reject) {
      var body = new FormData();
      let oArr = Object.keys(params);
      oArr.map((itm) => {
        body.append(itm, params[itm]);
      });

      api
        .post(url, body, configupdate)
        .then(function (response) {
          fulfill(response && response.data);
        })
        .catch(function (error) {
          loader(false);
          if (error && error.response) {
            let eres = error.response;
            handleError(eres.data);
            fulfill(eres.data);
          } else {
            toast.error("Network Error");
            reject(error);
          }
        });
    });
  }

  static multiImageUpload(url1, files, params = {}, key = "file") {
    let configupdate = {
      headers: { "Content-Type": "multipart/form-data" },
      params: params,
    };
    let url = getFullUrl(url1);
    setAuthorizationToken(api);
    let body = new FormData();

    let i = 0;
    for (let item of files) {
      let file = files.item(i);
      body.append(key, file);
      i++;
    }
    return new Promise(function (fulfill, reject) {
      api
        .post(url, body, configupdate)
        .then(function (response) {
          fulfill(response && response.data);
        })
        .catch(function (error) {
          loader(false);
          if (error && error.response) {
            let eres = error.response;
            handleError(eres.data);
            fulfill(eres.data);
          } else {
            toast.error("Network Error");
            reject(error);
          }
        });
    });
  }
}

export { api };
export default ApiClient;

